import { useGLTF } from "@react-three/drei";
import {
  Bloom,
  EffectComposer,
  SelectiveBloom,
} from "@react-three/postprocessing";
import { useEffect, useRef } from "react";
import { MeshBasicMaterial, MeshStandardMaterial } from "three";
const Model = () => {
  return (
    <>
      <EffectComposer multisampling={1} disableNormalPass>
        <Bloom
          luminanceThreshold={0}
          luminanceSmoothing={0.9}
          intensity={100}
        />
      </EffectComposer>
    </>
  );
};

export default Model;
